@defer {
  @if (errorService.error()?.status === 404) {
    <app-not-found></app-not-found>
  } @else if (errorService.error() && errorService.error()?.status !== 422) {
    <app-error></app-error>
  } @else if (bankTransferInstructions) {
    <app-payment-bank-transfer (back)="handleBankTransferInstructions();handlePaymentResult()" [bankTransferInstructions]="bankTransferInstructions"></app-payment-bank-transfer>
  } @else if (paymentResult === true || (errorService.error()?.status === 422 && errorService.error()?.error.errorCode === 'PAYMENT_ALREADY_DONE')) {
    <app-payment-verification></app-payment-verification>
  } @else if (paymentResult === false) {
    <app-payment-error (back)="handlePaymentResult()"></app-payment-error>
  } @else {
    <div class="container">
      <h1 class="nx-font-weight-bold">{{ 'Secure Payment' | transloco }}</h1>

      <p>
        {{ 'You\'re almost there! Complete your payment securely to access your service.' | transloco }}<br />
        {{ 'All transactions are encrypted and protected. If you have any questions, feel free to contact support.' | transloco }}
                @if (paymentData?.metadata?.['sellerName']) {
              <br />
              <span class="seller-name">{{ 'Seller name' | transloco }}: {{ paymentData?.metadata?.['sellerName'] }}</span>
            }
            @if (paymentData?.metadata?.['financialElementIds']) {
              <br/>
              <span class="invoice-number">{{ 'Invoice number' | transloco }}: {{ paymentData?.metadata?.['financialElementIds'] }}</span>
            }
            @if (paymentData?.metadata?.['collectionCaseId']) {
              <br />
              <span class="file-number">{{ 'File number' | transloco }}: {{ paymentData?.metadata?.['collectionCaseId'] }}</span>
            }
      </p>

      <lib-payment-card
        [paymentId]="paymentId"
        [payLabel]="'PAY' | transloco"
        [labels]="{
          settleLink: '↺ Settle Part of Your Balance' | transloco,
          of: 'OF' | transloco,
          modalTitle: 'Settle Part of Your Balance' | transloco,
          modalHintBefore: 'Enter an amount between' | transloco,
          modalHintAnd: 'and' | transloco,
          modalCancel: 'Cancel' | transloco,
          modalConfirm: 'Confirm' | transloco
        }"
        (paymentData)="handlePaymentData($event)"
        (paymentResult)="handlePaymentResult($event)"
        (bankTransferInstructions)="handleBankTransferInstructions($event)"
        (paymentError)="handlePaymentError($event)"
      ></lib-payment-card>
    </div>
  }
} @placeholder {
  <div class="spinner-container">
    <nx-spinner size="large"></nx-spinner>
  </div>
}
